<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <sarala-table :model="model" ref="table" :isExpansible="true">
                    <!-- BTN CREATE -->
                    <template #create-btn>
                        <v-btn
                            color="indigo"
                            class="white--text"
                            :to="{ name: 'productSale.create' }"
                        >
                            <v-icon left>mdi-plus</v-icon>
                            {{
                                $t('resources.default.add', {
                                    resource: $tc(
                                        'resources.productSale.name',
                                        1,
                                    ),
                                })
                            }}
                        </v-btn>
                    </template>

                    <template #charged="{ item }">
                        <v-icon v-if="item.charged" small color="green">
                            mdi-check
                        </v-icon>
                        <v-icon v-else small color="red">
                            mdi-close
                        </v-icon>
                    </template>
                    <template #status="{item}">
                        <v-chip
                            :color="item.statusColor"
                            text-color="white"
                            small
                        >
                            {{ item.status }}
                        </v-chip>
                    </template>
                    <template #action="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    icon
                                    tile
                                    v-on="on"
                                    :to="{
                                        name: 'productSale.edit',
                                        params: { id: item.id },
                                    }"
                                >
                                    <v-icon color="blue-grey" v-on="on"
                                        >mdi-pencil</v-icon
                                    >
                                </v-btn>
                            </template>
                            <span>{{ $t('resources.default.edit') }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    icon
                                    tile
                                    v-on="on"
                                    @click="syncItem(item)"
                                    :disabled="!item.charged"
                                    :loading="syncingItems.includes(item.id)"
                                >
                                    <v-icon color="blue-grey" v-on="on"
                                        >mdi-sync</v-icon
                                    >
                                </v-btn>
                            </template>
                            <span>{{ $t('resources.default.sync') }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    icon
                                    tile
                                    v-on="on"
                                    @click="deleteItem(item)"
                                    :disabled="
                                        item.charged &&
                                            item.status !== 'Cancelado'
                                    "
                                >
                                    <v-icon color="red" v-on="on"
                                        >mdi-delete</v-icon
                                    >
                                </v-btn>
                            </template>
                            <span>{{ $t('resources.default.delete') }}</span>
                        </v-tooltip>
                    </template>

                    <template #content="{item}">
                        <v-data-table
                            :headers="productSalePeriod.tableColumns"
                            :items="item.productSalePeriod"
                            :hide-default-footer="true"
                            :items-per-page="-1"
                            class="grey lighten-4"
                            width="100%"
                        >
                            <template v-slot:[`item.status`]="{ item }">
                                <v-chip :color="item.statusColor" dark>
                                    {{ item.status }}
                                </v-chip>
                            </template>
                            <template v-slot:[`item.url`]="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            icon
                                            tile
                                            v-on="on"
                                            @click="copyUrl(item.url)"
                                        >
                                            <v-icon color="blue-grey"
                                                >mdi-content-copy</v-icon
                                            >
                                        </v-btn>
                                    </template>
                                    <span>{{
                                        $t(
                                            'resources.productSalePeriod.hints.copyUrl',
                                        )
                                    }}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            icon
                                            tile
                                            :href="item.url"
                                            v-on="on"
                                            target="_blank"
                                        >
                                            <v-icon color="blue-grey"
                                                >mdi-open-in-new</v-icon
                                            >
                                        </v-btn>
                                    </template>
                                    <span>{{
                                        $t(
                                            'resources.productSalePeriod.hints.accessPaymentPage',
                                        )
                                    }}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            icon
                                            tile
                                            v-on="on"
                                            @click="cancelPeriod(item)"
                                            :disabled="!item.cancelable"
                                            :loading="
                                                cancelingPeriods.includes(
                                                    item.id,
                                                )
                                            "
                                        >
                                            <v-icon color="red"
                                                >mdi-cancel</v-icon
                                            >
                                        </v-btn>
                                    </template>
                                    <span>{{
                                        $t(
                                            'resources.productSalePeriod.hints.cancel',
                                        )
                                    }}</span>
                                </v-tooltip>
                            </template>
                        </v-data-table>
                    </template>
                </sarala-table>
            </v-col>
        </v-row>

        <confirm
            ref="confirmDialog"
            :confirmText="confirmDialogText"
            confirmColor="red darken-1"
        ></confirm>
    </v-container>
</template>

<script>
import SaralaTable from '@/shared/components/SaralaTable'
import ProductSale from '@/models/product/ProductSale'
import ProductSalePeriod from '@/models/product/ProductSalePeriod'
import Confirm from '@/components/dialogs/Confirm'

export default {
    components: {
        SaralaTable,
        Confirm,
    },

    data() {
        return {
            syncingItems: [],
            cancelingPeriods: [],
            confirmDialogText: '',
        }
    },

    computed: {
        model() {
            return new ProductSale()
        },
        productSalePeriod() {
            return new ProductSalePeriod()
        },
    },

    methods: {
        async deleteItem(model) {
            this.confirmDialogText = 'Excluir'
            let confirm = await this.$refs.confirmDialog.open(
                this.$t('resources.dialogs.confirm.delete.title'),
                this.$t('resources.dialogs.confirm.delete.content', {
                    resource: this.$tc('resources.productSale.name', 1),
                    article: 'a',
                }),
            )
            if (!confirm) return
            let res = await model.delete()
            if (!res) {
                this.$bus.$emit(
                    'notify',
                    'error',
                    this.$t('resources.feedbacks.errors.delete', {
                        resource: this.$tc('resources.productSale.name', 1),
                    }),
                )
                return
            }
            this.$refs.table.getItems()
            this.$bus.$emit(
                'notify',
                'success',
                this.$t('resources.feedbacks.success.delete', {
                    resource: this.$tc('resources.productSale.name', 1),
                }),
            )
        },

        async syncItem(item) {
            this.syncingItems.push(item.id)
            let res = await item.sync()
            this.syncingItems.pop(item.id)
            if (!res) return
            this.$refs.table.getItems()
            this.$bus.$emit(
                'notify',
                'success',
                this.$t('resources.feedbacks.success.sync', {
                    resource: this.$tc('resources.productSale.name', 1),
                }),
            )
        },

        async cancelPeriod(period) {
            this.confirmDialogText = this.$t(
                'resources.dialogs.confirm.cancel.confirm',
            )
            let confirm = await this.$refs.confirmDialog.open(
                this.$t('resources.dialogs.confirm.cancel.title'),
                this.$t('resources.dialogs.confirm.cancel.content', {
                    resource:
                        this.$tc(
                            'resources.productSalePeriod.name',
                            1,
                        ).toLowerCase() +
                        ' ' +
                        period.resume,
                }),
            )
            if (!confirm) return

            this.cancelingPeriods.push(period.id)
            let res = await period.cancel()
            this.cancelingPeriods.pop(period.id)
            if (!res) return

            this.$refs.table.getItems()
            this.$bus.$emit(
                'notify',
                'success',
                this.$t('resources.feedbacks.success.cancel'),
            )
        },

        async copyUrl(url) {
            if (!navigator.clipboard || !url) {
                this.$bus.$emit(
                    'notify',
                    'error',
                    this.$t('resources.feedbacks.errors.copy', {
                        resource: this.$t(
                            'resources.productSalePeriod.attributes.url',
                        ),
                    }),
                )
                return
            }

            await navigator.clipboard.writeText(url)

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('resources.feedbacks.success.copy', {
                    resource: this.$t(
                        'resources.productSalePeriod.attributes.url',
                    ),
                }),
            )
        },
    },
}
</script>

<style></style>
